import React from 'react';
import {withRouter} from "react-router-dom";
import { connect } from 'react-redux';

import Loading from "../../components/Loading/index";
import { getQuestion } from '../../redux/actions/questionActions';

class QuestionPreview extends React.Component {
    componentDidMount() {
        const { match, sessionData, loading, question, fceGetQuestion } = this.props;
        const questionId = match.params.id;
        const token = sessionData ? sessionData.accessToken : null;
        if (token && questionId && !loading && (!question || !question.answers)) {
            fceGetQuestion(token, questionId);
        }
    }

    componentWillReceiveProps(nextProps, nextContext) {
        const { match, sessionData, loading, question, fceGetQuestion } = nextProps;
        const questionId = match.params.id;
        const token = sessionData ? sessionData.accessToken : null;
        if (token && questionId && !loading && (!question || !question.answers)) {
            fceGetQuestion(token, questionId);
        }
    }

    render() {
        const { question, loading } = this.props;
        if (!question) {
            if (loading) {
                return <Loading />;
            }
            return null;
        }
        const { name, text, explanation, paragraph, lawLink, difficulty, timeframe, pointsValue, moneyValue, pictureLink, tagIds, answers } = question;
        const url = pictureLink ? `${__APIURL__}/${pictureLink}` : "";
        return (
            <div className="x-panel">
                <div className="x-title">
                    <h2>Otázka č. {name}</h2>
                    <div className="clearfix"/>
                </div>
                {
                    loading ?
                        <div className="x-content">
                            <Loading/>
                        </div> :
                        <div className="x-content">
                            <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                <h2>Základní údaje:</h2>
                                <table className="table table-striped">
                                    <tbody>
                                    <tr>
                                        <th>Znění otázky:</th>
                                        <td>{text}</td>
                                    </tr>
                                    <tr>
                                        <th>Vysvětlení otázky:</th>
                                        <td>{explanation}</td>
                                    </tr>
                                    <tr>
                                        <th>Paragraf:</th>
                                        <td>{paragraph}</td>
                                    </tr>
                                    <tr>
                                        <th>Odkaz na zákon:</th>
                                        <td><a href={lawLink} target="_blank">{lawLink}</a></td>
                                    </tr>
                                    <tr>
                                        <th>Obtížnost:</th>
                                        <td>{difficulty}</td>
                                    </tr>
                                    <tr>
                                        <th>Časová náročnost:</th>
                                        <td>{timeframe}</td>
                                    </tr>
                                    <tr>
                                        <th>Hodnota v bodech:</th>
                                        <td>{pointsValue}</td>
                                    </tr>
                                    <tr>
                                        <th>Hodnota v penězích:</th>
                                        <td>{moneyValue}</td>
                                    </tr>
                                    </tbody>
                                </table>
                            </div>
                            {
                                tagIds && tagIds.length > 0 &&
                                <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                    <h2>Tagy:</h2>
                                    {
                                        [...tagIds].map((tag) => <span key={tag._id} className="myTag">{tag.name}</span>)
                                    }
                                </div>
                            }
                            <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                <h2>Odpovědi:</h2>
                                <table className="table">
                                    <thead>
                                    <tr>
                                        <th>Číslo odpovědi</th>
                                        <th>Znění odpovědi</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    {
                                        answers && answers.map((answer, index) => {
                                            let correct = answer.correctness ? 'correct' : 'incorrect';
                                            return (
                                                <tr key={index} className={correct}>
                                                    <td>{answer.name}</td>
                                                    <td>{answer.text}</td>
                                                </tr>
                                            )
                                        })
                                    }
                                    </tbody>
                                </table>
                            </div>
                            {pictureLink && <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                <h2>Obrázek:</h2>
                                <img src={url} alt="Obrázek otázky"/>
                            </div>}
                        </div>
                }
            </div>
        );
    }
}

const mapStateToProps = (state, ownProps) => {
    const questionId = ownProps.match.params.id;
    return {
        loading: state.questions.loading,
        question: questionId && state.questions.items ? state.questions.items[questionId] : null
    }
};

const mapDispatchToProps = (dispatch) => ({
    fceGetQuestion: (token, questionId, callback) => dispatch(getQuestion(token, questionId)),
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(QuestionPreview));



/** WEBPACK FOOTER **
 ** ./src/containers/Questions/QuestionPreview.js
 **/